import React from 'react';
import {Link} from 'react-router-dom';
import Meta from '../model/Meta';

const ContactTy = (props)=>{
    const meta = {
        title: "Thank you for getting in touch",
        description: "One of our team will get back to you shortly"
    }
    return(
        <div className="page page-inner ty p-5">
            <Meta {...meta}/>
            <div className="container-fluid">
                <div className="container">
                    <h4>Thank you for getting in touch!</h4>
                    <br />
                    <p>We appreciate you contacting us. One of our team member will get back to you shortly.</p>
                    <p>Have a great day!</p>
                    <br />
                    <Link to="/">Back to Home page</Link>
                </div>
            </div>
        </div>
    )
}
export default ContactTy;


// WEBPACK FOOTER //
// ./src/pages/ContactTy.js